import axios from 'axios'

import { BASE_URL } from '@/api/api.constants'
import { SpendLensCategoryResponseModel } from '@/types/clarityLens'

export const getSpendLensCategories = async (
  branchName: string,
  startDate: string,
  endDate: string
): Promise<SpendLensCategoryResponseModel[]> => {
  try {
    const response = await axios.get(`${BASE_URL}/spend-lens/categories`, {
      params: {
        start_date: startDate,
        end_date: endDate,
        dcn: branchName,
      },
    })

    return response.data?.categories
  } catch (error) {
    throw error
  }
}
